import { EditorState } from 'draft-js'

export enum ErrorType {
  MAX_LENGTH = 'max_length',
  REQUIRED = 'required'
}

export const validateEditorTextLength = ({
  text,
  editorState,
  maxPlainTextLength,
  required
}: {
  text: string
  editorState: EditorState
  maxPlainTextLength: number
  required?: boolean
}): { status: 'handled' | 'not-handled'; errorType?: ErrorType } => {
  const totalLength = editorState.getCurrentContent().getPlainText().length + text.length

  if (totalLength > maxPlainTextLength) {
    return { status: 'handled', errorType: ErrorType.MAX_LENGTH }
  }

  if (required && totalLength === 0) {
    return { status: 'handled', errorType: ErrorType.REQUIRED }
  }

  return { status: 'not-handled' }
}
